import { Component, Input, OnInit } from '@angular/core';
import { NotyService } from '@app/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';

export type ModalResult = {};
export interface ModalPublicProperties {}

@Component({
  selector: 'app-endpoint-secret-modal',
  templateUrl: './endpoint-secret-modal.component.html',
  styleUrls: ['./endpoint-secret-modal.component.scss'],
  standalone: false
})
export class EndpointSecretModalComponent implements ModalPublicProperties, OnInit {
  constructor(
    public modal: NgbActiveModal,
    private clipboardService: ClipboardService,
    private notyService: NotyService,
    private translateService: TranslateService
  ) {}
  @Input() secret: string;

  ngOnInit(): void {}

  copyToClipboard(content: string) {
    this.clipboardService.copyFromContent(content);
    this.notyService.success(this.translateService.instant('shared.textCopySuccess'));
  }
}
